import { Condition } from "@/utils/condition/condition";

export const LOYALTY_BARCODE_PREFIX = "29";

export class LoyaltyConfig {
	Enabled:boolean = false;
	AlwaysShowButton:boolean = false;
	PointsPerEuro:number = 1;
	ExclusionFilters:Condition[] = [];
	RedeemStepPoints:number = 500;
	RedeemStepEuro:number = 5;
	EarnSaleTypeIDs:number[] = [1, 9];

	public constructor(data?:any){
		if (!data) return;
		this.Enabled = data.Enabled || false;
		this.AlwaysShowButton = data.AlwaysShowButton || false;
		this.PointsPerEuro = data.PointsPerEuro || 0;
		this.ExclusionFilters = (data.ExclusionFilters || []).map((f:any)=>new Condition(f));
		this.RedeemStepPoints = data.RedeemStepPoints || 0;
		this.RedeemStepEuro = data.RedeemStepEuro || 0;
		this.EarnSaleTypeIDs = [...(data.EarnSaleTypeIDs || [])];
	}

	public getJSON(){
		return {
			Enabled: this.Enabled,
			AlwaysShowButton: this.AlwaysShowButton,
			PointsPerEuro: this.PointsPerEuro,
			ExclusionFilters: this.ExclusionFilters.map(f=>f.getJSON()),
			RedeemStepPoints: this.RedeemStepPoints,
			RedeemStepEuro: this.RedeemStepEuro,
			EarnSaleTypeIDs: [...this.EarnSaleTypeIDs]
		};
	}

	public getRedeemableSteps(balance:number):number {
		if (this.RedeemStepPoints <= 0) return 0;
		return Math.floor(balance / this.RedeemStepPoints);
	}

	public getPointValue():number {
		if (this.RedeemStepPoints <= 0) return 0;
		return this.RedeemStepEuro / this.RedeemStepPoints;
	}

	public getNextRewardPoints(balance:number):number {
		if (this.RedeemStepPoints <= 0) return 0;
		if (balance < 0) return this.RedeemStepPoints;
		return (Math.floor(balance / this.RedeemStepPoints) + 1) * this.RedeemStepPoints;
	}

	public getEarnPreview(typeID:number, rows:{SaleRowConfig:{LoyaltyRedemption?:boolean}, TotalPriceIncVat:number}[]):number {
		if (typeID != 2 && this.EarnSaleTypeIDs.indexOf(typeID) == -1) return 0;
		let base = 0;
		for (let row of rows) {
			if (row.SaleRowConfig.LoyaltyRedemption) continue;
			if (this.ExclusionFilters.length > 0 && Condition.checkConditions(this.ExclusionFilters, row)) continue;
			base += row.TotalPriceIncVat;
		}
		base = Math.round(base * 100) / 100;
		let points = Math.floor(Math.abs(base) * this.PointsPerEuro + 1e-9);
		return base < 0 ? -points : points;
	}
}
